/**
 * --------------------------------------------------------------------------
 * CoreUI PRO index.umd.js
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

import Alert from './src/alert.js'
import Autocomplete from './src/autocomplete.js'
import Button from './src/button.js'
import Calendar from './src/calendar.js'
import Carousel from './src/carousel.js'
import Chip from './src/chip.js'
import ChipInput from './src/chip-input.js'
import ChipSet from './src/chip-set.js'
import Collapse from './src/collapse.js'
import DatePicker from './src/date-picker.js'
import DateRangePicker from './src/date-range-picker.js'
import Dropdown from './src/dropdown.js'
import LoadingButton from './src/loading-button.js'
import Modal from './src/modal.js'
import MultiSelect from './src/multi-select.js'
import Navigation from './src/navigation.js'
import Offcanvas from './src/offcanvas.js'
import OTPInput from './src/otp-input.js'
import PasswordInput from './src/password-input.js'
import Popover from './src/popover.js'
import RangeSlider from './src/range-slider.js'
import Rating from './src/rating.js'
import ScrollSpy from './src/scrollspy.js'
import SearchButton from './src/search-button.js'
import Sidebar from './src/sidebar.js'
import Stepper from './src/stepper.js'
import Tab from './src/tab.js'
import TimePicker from './src/time-picker.js'
import Toast from './src/toast.js'
import Tooltip from './src/tooltip.js'

export default {
  Alert,
  Autocomplete,
  Button,
  Calendar,
  Carousel,
  Chip,
  ChipInput,
  ChipSet,
  Collapse,
  DatePicker,
  DateRangePicker,
  Dropdown,
  LoadingButton,
  Modal,
  MultiSelect,
  Navigation,
  Offcanvas,
  OffCanvas: Offcanvas,
  OTPInput,
  PasswordInput,
  Popover,
  RangeSlider,
  Rating,
  ScrollSpy,
  SearchButton,
  Sidebar,
  Stepper,
  Tab,
  TimePicker,
  Toast,
  Tooltip
}
